import React, { createContext, ReactNode, useContext } from 'react';

import { signalRService } from './SignalRService';

const SignalRContext = createContext(signalRService);

export const SignalRProvider = ({ children }: { children: ReactNode }) => {
  // useEffect(() => {
  //   const token = localStorage.getItem('ACCESS_TOKEN');
  //
  //   const setupSignalR = async () => {
  //     await signalRService.start(String(token)); // wait for connection
  //   };
  //
  //   setupSignalR();
  //
  //   return () => {
  //     signalRService.stop();
  //   };
  // }, []);

  return <SignalRContext.Provider value={signalRService}>{children}</SignalRContext.Provider>;
};

export const useSignalR = () => useContext(SignalRContext);
